import { createFileRoute } from "@tanstack/react-router"

// Import the existing campaign preview page
import CampaignPreview from "@/pages/jobs/campaigns/preview"

export const Route = createFileRoute("/_screen/campaign/preview")({
  component: CampaignPreviewPage
})

function CampaignPreviewPage() {
  return <CampaignPreview />
}
